// Format a signal value/label by taking the last segment after '.' then
// replacing underscores with spaces and Title Casing each word.
const formatText = (label: string): string => {
	const str = String(label);
	const last = str.split(".").filter(Boolean).pop() || str;
	return last
		.split(/[_\s-]+/)
		.filter(Boolean)
		.map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
		.join(" ")
		.replace(/\bP2p\b/gi, "P2P");
};

export { formatText };
